<template>
  <div class="home-container" @scroll="handleScroll">
    <div v-if="!userInfo.employeeName && !exUserInfo.employeeName" class="page-nav clearfix"
      :class="opacityStatus ? 'not-carousel-field' : ''">
      <div class=" common-block">
        <div class="page-nav-left clearfix">
          <el-image class="nav-logo" :src="logoUrl"></el-image>
          <div class="nav-title">慈脉藏书阁</div>
        </div>
        <div class="page-nav-right clearfix">
          <div class="nav-free-use" @click="loginHandle">免费使用</div>
          <div class="nav-login" @click="loginHandle">登录</div>
        </div>
      </div>
    </div>
    <div class="home-carousel">
      <el-carousel indicator-position="inside" :interval="10000">
        <el-carousel-item v-for="(item, i) in carouselList" :key="item + i">
          <div class="carousel-main common-block">
            <div class="carousel-main-left">
              <div class="carousel-title">{{ item.title }}</div>
              <div class="carousel-desc">{{ item.text }}</div>
              <div class="carousel-link" @click="loginHandle(item.type)">
                <span>免费使用</span>
                <div class="arrow-icon">
                  <i class="el-icon-right"></i>
                </div>
              </div>
            </div>
            <el-image class="carousel-image" :src="item.img_url" fit="cover"></el-image>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="home-main common-block">
      <div class="pc-content">
        <div class="picture-article clearfix">
          <div class="article-content mg-right">
            <div class="title">中医书籍库</div>
            <div class="subtitle">阅览中医书籍文库内容</div>
            <div class="desc">
              现已整理古今600余本中医书籍，按拼音、标签分类，支持全文检索、书名检索；含经论、伤寒、金匮、内科、外科、妇科、儿科、五官、针灸、医论、医案、养生等主题。书按章节目录编排展示，查阅方便。</div>
          </div>
          <div class="picture-content mg-left">
            <el-image :src="bookImg"></el-image>
          </div>
        </div>
        <div class="picture-article clearfix">
          <div class="picture-content mg-right">
            <el-image :src="medicalImg"></el-image>
          </div>
          <div class="article-content mg-left article-block">
            <div class="title">中药材名录</div>
            <div class="subtitle">药材药理，一目了然</div>
            <div class="desc">
              名录含10000余种中药材，涵盖性味、归经、功能主治、用法用量、禁忌名家论述等</div>
          </div>

        </div>
        <div class="picture-article clearfix">
          <div class="article-content mg-right">
            <div class="title">中医学类文章</div>
            <div class="subtitle">百年医术传承人撰写分享</div>
            <div class="desc">
              徐明之，慈脉中医百年医术第四代传承人，6年自研出中医AI；文章内容精选自徐明之过往撰写的中医类文章</div>
          </div>
          <div class="picture-content mg-left">
            <el-image :src="articleImg"></el-image>
          </div>
        </div>
      </div>
      <div class="mobile-content">
        <div class="picture-article">
          <div class="article-content">
            <div class="title">中医书籍库</div>
            <div class="subtitle">阅览中医书籍文库内容</div>
            <div class="desc">
              现已整理古今600余本中医书籍，按拼音、标签分类，支持全文检索、书名检索；含经论、伤寒、金匮、内科、外科、妇科、儿科、五官、针灸、医论、医案、养生等主题。书按章节目录编排展示，查阅方便。</div>
          </div>
          <div class="picture-content">
            <el-image :src="bookImg"></el-image>
          </div>
        </div>
        <div class="picture-article">
          <div class="article-content">
            <div class="title">中药材名录</div>
            <div class="subtitle">药材药理，一目了然</div>
            <div class="desc">
              名录含10000余种中药材，涵盖性味、归经、功能主治、用法用量、禁忌名家论述等</div>
          </div>
          <div class="picture-content">
            <el-image :src="medicalImg"></el-image>
          </div>
        </div>
        <div class="picture-article">
          <div class="article-content">
            <div class="title">中医学类文章</div>
            <div class="subtitle">百年医术传承人撰写分享</div>
            <div class="desc">
              徐明之，慈脉中医百年医术第四代传承人，6年自研出中医AI；文章内容精选自徐明之过往撰写的中医类文章</div>
          </div>
          <div class="picture-content">
            <el-image :src="articleImg"></el-image>
          </div>
        </div>
      </div>
    </div>
    <div class="home-bottom-bg"></div>
    <page-footer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageFooter from '@/components/pageFooter.vue';
export default {
  name: "HomeView",
  data() {
    return {
      logoUrl: require('@/assets/images/logo5.png'),
      carouselList: [
        {
          type: 'book',
          title: '中医书籍库',
          text: '6800+本中医书籍文库内容',
          img_url: require('@/assets/images/home/book.png'),
          link: ''
        },
        {
          type: 'medical',
          title: '中药材名录',
          text: '10000+种中药材资料内容',
          img_url: require('@/assets/images/home/medicinal.png'),
          link: ''
        },
        {
          type: 'article',
          title: '中医学类文章',
          text: '百年医术传承人精选文档分享',
          img_url: require('@/assets/images/home/article.png'),
          link: ''
        }
      ],
      bookImg: require('@/assets/images/home/book_intro.png'),
      medicalImg: require('@/assets/images/home/medical_intro.png'),
      articleImg: require('@/assets/images/home/article_intro.png'),
      opacityStatus: false,
    }
  },
  computed: {
    ...mapGetters(["userInfo", "exUserInfo"]),
  },
  components: {
    PageFooter
  },
  mounted () {
    this.autoLogin();
  },
  methods: {
    autoLogin(){
      const urlParams = new URLSearchParams(location.hash);
      const token = urlParams.get('token');
      if (token) {
        localStorage.setItem('tokenLogin', token);
        this.$store.dispatch("tokenLogin")
        // 清除url里的参数
        window.history.replaceState({}, '', '/');
        // 重新加载页面
        // window.location.reload();
      }
      
    },
    loginHandle(type) {
      if (this.userInfo.employeeName) {
        if (type === 'book') {
          this.$router.push('/pageBook')
        } else if (type === 'article') {
          this.$router.push('/pageArticle')
        } else if (type === 'medical') {
          this.$router.push('/pageSearch')
        }
      } else {
        this.$router.push('/login')
      }
    },
    handleScroll(event) {
      // 检查滚动位置
      this.opacityStatus = event.target.scrollTop > 570; // 假设100px滚动后变化
    }
  },
};
</script>
<style scoped lang="scss">
.el-footer {
  height: 30px;
  font-size: 12px;
  line-height: 16px;
  padding-top: 2px;
  background: #eee;
  text-align: center;
  overflow: hidden;
  position: relative;
  z-index: 100;

  .yw_bq {
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 2px;
  }
}

.page-nav {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 72px;
  z-index: 12;
  background-color: #fff;
  opacity: 0.7;
  font-family: PingFang-SC, PingFang-SC;

  &.not-carousel-field {
    opacity: 1;
    border-bottom: 1px solid #eee;
  }

  .page-nav-left {
    float: left;
    margin-top: 11px;

    .nav-logo {
      float: left;
      width: 50px;
    }

    .nav-title {
      float: left;
      font-weight: bold;
      font-size: 24px;
      line-height: 50px;
      letter-spacing: 4px;
      text-align: justify;
      font-style: normal;
      margin-left: 10px;
    }
  }

  .page-nav-right {
    float: right;

    .nav-login {
      float: right;
      font-weight: 400;
      font-size: 20px;
      line-height: 30px;
      cursor: pointer;
      margin-top: 10px;
      margin-right: 30px;
      padding: 10px;

      &:hover {
        color: #D7000F;
      }
    }

    .nav-free-use {
      float: right;
      font-size: 20px;
      color: #D7000F;
      line-height: 36px;
      border-radius: 27px;
      padding: 0 20px;
      border: 2px solid #D7000F;
      margin-top: 16px;
      cursor: pointer;

      &:hover {
        background: #D7000F;
        color: #fff;
      }
    }
  }
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.mg-left {
  margin-left: 40px;
}

.mg-right {
  margin-right: 40px;
}

.common-block {
  width: 1200px;
  margin: 0 auto;

  .pc-content {
    display: block;
  }

  .mobile-content {
    display: none;
  }
}

.home-container {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  font-family: SourceHanSansCN, SourceHanSansCN;
  min-width: 1200px;
  overflow: auto;

  .home-carousel {
    width: 100%;
    min-width: 1200px;
    height: 570px;
    background: url('@/assets/images/home/home_carousel_bg.png') no-repeat;
    background-size: cover;
    background-position: center 0;
    /* 设置多浏览器支持 */
    -webkit-background-size: cover;
    /*设置背景图片的尺寸*/
    -o-background-size: cover;
    -moz-background-size: cover;

    :deep .el-carousel__indicators {
      bottom: 30px;

      .el-carousel__indicator {
        .el-carousel__button {
          width: 32px;
          height: 4px;
          background: #F79AA5;
          opacity: 1;
        }

        &.is-active {
          .el-carousel__button {
            width: 32px;
            height: 4px;
            background: #D7000F;
            opacity: 1;
          }
        }
      }
    }

    :deep .el-carousel__container {
      width: 100%;
      height: 570px;
      color: red;



      .carousel-main {
        position: relative;
        margin-top: 72px;

        .carousel-main-left {
          margin-top: 180px;

          .carousel-title {
            font-weight: bold;
            font-size: 48px;
            color: #191919 !important;
            line-height: 60px;
            letter-spacing: 8px;
          }

          .carousel-desc {
            font-size: 24px;
            color: #4C4C4C !important;
            line-height: 45px;
            letter-spacing: 3px;
            margin: 30px 0 60px;
          }

          .carousel-link {
            position: relative;
            display: block;
            width: 240px;
            height: 70px;
            background: #D7000F;
            border: 2px solid transparent;
            border-radius: 45px;
            font-size: 26px;
            color: #FFFFFF;
            line-height: 70px;
            padding: 0 20px;
            cursor: pointer;

            &:hover {
              color: #D7000F !important;
              border: 2px solid #D7000F;
              background: #fff;

              .arrow-icon {
                background: #D7000F;

                .el-icon-right {
                  color: #fff;
                }
              }
            }

            .arrow-icon {
              position: absolute;
              right: 20px;
              top: 10px;
              width: 50px;
              height: 50px;
              background: #fff;
              border-radius: 50%;

              .el-icon-right {
                position: absolute;
                left: 50%;
                top: 50%;
                margin-top: -16px;
                margin-left: -16px;
                font-size: 32px;
                font-weight: bold;
                color: #D7000F;
              }
            }
          }
        }

        .carousel-image {
          position: absolute;
          right: 0;
          top: 50%;
          width: 800px;
          height: auto;
          margin-top: -120px;
        }
      }

    }
  }

  .home-main {
    padding-bottom: 50px;

    .picture-article {
      position: relative;
      margin-top: 100px;

      .article-content {
        float: left;
        width: 560px;

        &.article-block {
          text-align: right;

          .subtitle {
            &::after {
              position: absolute;
              right: 0;
              left: inherit;
            }
          }
        }


        .title {
          font-weight: bold;
          font-size: 40px;
          color: #191919 !important;
          line-height: 60px;
          margin: 20px 0;
        }

        .subtitle {
          position: relative;
          font-weight: 400;
          font-size: 26px;
          color: #4C4C4C !important;
          line-height: 39px;
          letter-spacing: 4px;
          margin-bottom: 50px;

          &::after {
            position: absolute;
            left: 0;
            bottom: -30px;
            content: '';
            width: 40px;
            height: 6px;
            background: #D7000F;
            margin-top: 15px;
          }
        }

        .desc {
          font-weight: 400;
          font-size: 16px;
          color: #999999;
          line-height: 26px;
        }
      }

      .picture-content {
        float: left;
        width: 500px;
        height: 297px;
        box-shadow: 6px 6px 16px 0px #F6AAAF;
        border: 16px solid #F79AA5;
        background: linear-gradient(0, rgba(215, 0, 15, 0) 0%, rgba(215, 0, 15, 0.06) 62%, rgba(215, 0, 15, 0) 100%);
      }
    }
  }

  .home-bottom-bg {
    position: absolute;
    bottom: -1040px;
    width: 100%;
    min-width: 1200px;
    height: 703px;
    background: url('@/assets/images/home/home_bottom_bg.png') no-repeat;
    background-size: cover;
    background-position: center 0;
    /* 设置多浏览器支持 */
    -webkit-background-size: cover;
    /*设置背景图片的尺寸*/
    -o-background-size: cover;
    -moz-background-size: cover;
  }
}

.dark {
  .home-container {
    .carousel-title {
      color: #ddd !important;
    }

    .carousel-desc {
      color: #ddd !important;
    }

    .home-main {

      .title,
      .subtitle {
        color: #ddd !important;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  :deep .el-footer {
    .yw_bq {
      font-size: 10px !important;
    }
  }
  .common-block {
    width: 100%;
    margin: 0 auto;

    .pc-content {
      display: none;
    }

    .mobile-content {
      display: block;
    }
  }

  .mg-left {
    margin-left: 10px;
  }

  .mg-right {
    margin-right: 10px;
  }

  .home-container {
    min-width: 100%;
    .home-carousel {
      min-width: 100px;
      height: 250px;

      :deep .el-carousel__indicators {
        bottom: 4px;

        .el-carousel__indicator {
          .el-carousel__button {
            width: 20px;
            height: 2px;
          }

          &.is-active {
            .el-carousel__button {
              width: 20px;
              height: 2px;
            }
          }
        }
      }

      :deep .el-carousel__container {
        width: 100%;
        height: 250px;

        .carousel-main {
          margin-top: 32px;

          .carousel-main-left {
            margin-top: 90px;

            .carousel-title {
              font-size: 18px;
              line-height: 20px;
              margin: 10px;
              letter-spacing: 2px;
            }

            .carousel-desc {
              font-size: 14px;
              line-height: 20px;
              margin: 10px;
              letter-spacing: 1px;
              margin-top: 20px;
            }

            .carousel-link {
              width: 90px;
              height: 36px;
              border: 1px solid transparent;
              border-radius: 20px;
              font-size: 14px;
              line-height: 36px;
              padding: 0 10px;
              margin: 10px;
              margin-top: 20px;

              &:hover {
                border: 1px solid #D7000F;
              }

              .arrow-icon {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                height: 24px;

                .el-icon-right {
                  margin-top: -10px;
                  margin-left: -10px;
                  font-size: 20px;
                }
              }
            }
          }

          .carousel-image {
            right: 5px;
            width: 200px;
            margin-top: -10px;
          }
        }
      }
    }

    .home-main {
      .picture-article {
        position: relative;
        margin-top: 10px;

        .article-content {
          float: inherit;
          width: calc(100% - 30px);
          margin: 0 15px;

          &.article-block {
            text-align: right;

            .subtitle {
              &::after {
                position: absolute;
                right: 0;
                left: inherit;
              }
            }
          }


          .title {
            font-weight: bold;
            font-size: 20px;
            line-height: 30px;
            margin: 0;
            margin-top: 15px;
          }

          .subtitle {
            position: relative;
            font-weight: 400;
            font-size: 16px;
            color: #4C4C4C;
            line-height: 30px;
            letter-spacing: 4px;
            margin-bottom: 20px;

            &::after {
              position: absolute;
              left: 0;
              bottom: -10px;
              content: '';
              width: 30px;
              height: 4px;
              background: #D7000F;
              margin-top: 15px;
            }
          }

          .desc {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 10px;
          }
        }

        .picture-content {
          float: initial;
          width: calc(100% - 50px);
          height: 222px;
          box-shadow: 3px 3px 10px 0px #F6AAAF;
          border: 10px solid #F79AA5;
          margin: 0 15px;
        }
      }
    }

    .home-bottom-bg {
      position: absolute;
      bottom: -400px;
      width: 100%;
      min-width: 100px;
      height: 400px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .page-nav {
    width: 100%;
    height: 48px;

    .page-nav-left {
      margin-top: 6px;

      .nav-logo {
        width: 36px;
      }

      .nav-title {
        font-size: 20px;
        line-height: 36px;
        letter-spacing: 1px;
        margin-left: 6px;
      }
    }

    .page-nav-right {
      .nav-login {
        font-size: 16px;
        line-height: 30px;
        margin-top: 0;
        margin-right: 10px;
        padding: 8px;
      }

      .nav-free-use {
        font-size: 16px;
        line-height: 26px;
        border-radius: 25px;
        padding: 0 10px;
        border: 1px solid #D7000F;
        margin-top: 10px;
        margin-right: 10px;
      }
    }
  }
  .common-block {
    width: 100%;
    margin: 0 auto;
  }
}


</style>
